import { render, staticRenderFns } from "./paper-list-page.html?vue&type=template&id=2d6a8f29&"
import script from "./paper-list-page.ts?vue&type=script&lang=ts&"
export * from "./paper-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./paper-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports